<template>
  <div class="d-block">
    <slot name="header">
      <p class="h3 font-weight-bold p-0 my-2">{{ titlePage }}</p>
    </slot>
    <!-- base alert system -->
    <base-alert-system
      v-if="useAlertSystem && alert.show"
      :message="alert.message"
      :error="alert.error"
      @hide-alert="
        () => {
          alert.show = false;
        }
      "
    />
    <slot>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </slot>
  </div>
</template>

<script>
export default {
  name: "TheEdicAdminGlobalContent",
  props: {
    titlePage: String,
    useAlertSystem: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      alert: {
        show: false,
        error: false,
        message: "",
      },
    };
  },
  created() {
    document.title = this.titlePage;
  },
  mounted() {
    this.$eventBus.$on("update-alert-system", this.handleAlertSystem);
  },
  methods: {
    handleAlertSystem({ error, message }) {
      this.alert = {
        show: true,
        error: error,
        message: message,
      };
      if (this.alert.show) {
        this.scrollTopWindow();
      }
    },
  },
};
</script>
